var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.632 1.002C15.131.939 11.138 2.77 8.61 5.612a9.479 9.479 0 00-6.499 2.771.375.375 0 00.21.637l2.88.413-.356.398a.374.374 0 00.015.514l4.803 4.808a.373.373 0 00.514.015l.398-.356.412 2.883c.02.14.131.244.265.288a.34.34 0 00.107.017.422.422 0 00.29-.12 9.478 9.478 0 002.743-6.482c2.842-2.535 4.687-6.531 4.605-10.031a.376.376 0 00-.365-.365zm-3.444 6.457a1.861 1.861 0 01-1.321.547c-.48 0-.957-.182-1.321-.547a1.87 1.87 0 112.643 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.467 12.68c-.699.698-1.658 3.854-1.765 4.21a.327.327 0 00.407.408c.357-.107 3.513-1.066 4.211-1.765a2.02 2.02 0 000-2.853 2.02 2.02 0 00-2.853 0z",
    fill: "currentColor"
  })));
}

export default SvgRocket;